import { ApiEndpointHandler } from '@sonar-software/sonar-http';
import { KeyPaginationQueryParams, PaginatedResource, PaginationDirection } from '@sonar-software/sonar-ts-types';

export function createGetFullKeyEndpointFromExisting<
	TRequest extends KeyPaginationQueryParams,
	TResponse extends PaginatedResource<unknown>
>(
	endpoint: ApiEndpointHandler<TRequest, TResponse>,
	count = 100
): ApiEndpointHandler<undefined | Partial<TRequest>, TResponse> {
	return async(request?: Partial<TRequest>) => {
		let response = await endpoint({
			...request,
			count,
			paginationDirection: PaginationDirection.Forward
		} as TRequest);

		if (!response.data) {
			return response;
		}

		const results = [ ...response.data.results ];

		while (response.data?.nextKey) {
			// eslint-disable-next-line no-await-in-loop
			response = await endpoint({
				...request,
				count,
				key: response.data.nextKey,
				paginationDirection: PaginationDirection.Forward
			} as TRequest);

			if (response.data) {
				results.push(...response.data.results);
				response.data.results = results;
				response.data.prevKey = undefined;
			}
		}

		return response;
	};
}
